/**
 * Created by ModelParser
 * Date: 18-09-2022.
 * Time: 09:42.
 */
import {BloodPressureDefinition} from './definitions/BloodPressureDefinition';
import {Client} from "@/core/services/MedicaPro/models/Client";

export class BloodPressure extends BloodPressureDefinition {

    constructor(json?: any) {
        super(json);
    }

    public static Create(client: Client): BloodPressure {
        const item = new BloodPressure();
        item.client_id = client.id;
        return item;
    }

    public getDate(): Date {
        return new Date(this.date ?? '');
    }

}
